module.exports = __webpack_public_path__ + "img/resource-tech-image-06.8b527db7.jpg";